import { FC, useEffect } from 'react';
import { Checkbox, Stack, Typography } from '@mui/material';
import FormField from '../../../../../../components/Form/FormField';
import { AccessProviderConfig } from '../GrantAccessToProvider';

interface AppsflyerDetailsProps {
  config: AccessProviderConfig | null;
  loading: boolean;
  formValues: Record<string, string | string[]>;
  handleInputChange: any;
  setIsFormValid: (isValid: boolean) => void;
  handleMonthlyRefreshChange: () => void;
  monthlyRefreshStatus: boolean;
}

const AppsflyerDetails: FC<AppsflyerDetailsProps> = ({
  config,
  loading,
  formValues,
  handleInputChange,
  setIsFormValid,
  handleMonthlyRefreshChange,
  monthlyRefreshStatus,
}) => {
  useEffect(() => {
    if (formValues?.accountName && formValues?.iapMargin) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [formValues]);

  return (
    <Stack gap={'1rem'} padding={'1.5rem 1rem'}>
      {/* Info Section */}
      {config?.info}

      {/* Standard fields */}
      {config?.fields?.map((field) => (
        <div key={field.name} className="form-field">
          <FormField
            field={field}
            formValues={formValues}
            handleInputChange={handleInputChange}
            loading={loading}
          />
        </div>
      ))}
      <Typography
        fontSize={'0.875rem'}
        lineHeight={'1.25rem'}
        fontWeight={700}
        color={'#162936'}
        maxWidth={'100%'}
        letterSpacing={'-0.035rem'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        }}
      >
        <Checkbox
          checked={monthlyRefreshStatus}
          onChange={handleMonthlyRefreshChange}
          sx={{
            color: '#7FBCAD',
          }}
        />
        I authorise PvX to securely refresh my data each month for accurate reporting.
      </Typography>
      <ul
        style={{
          paddingLeft: '2rem',
          margin: 0,
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          fontWeight: 500,
          color: '#6C6C6C',
        }}
      >
        <li>Dashboards will be refreshed monthly by the 10th of each month.</li>
        <li>You can turn this off any time from ‘Settings’.</li>
      </ul>
    </Stack>
  );
};

export default AppsflyerDetails;
